import Icon from 'veui/components/Icon'
import { IconMusic } from 'dls-icons-vue'

Icon.register('music', IconMusic)
